import Page from './Page';

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/index.ts